import { useMemo } from "react"
import { Errand } from "@/model/cleaningInfo"

export const useErrandProgress = (errands: Errand[]) => {
    return useMemo(() => {
        const undoneErrands = errands.filter(
            ({ pictures }) => pictures.length === 0
        )

        return {
            undoneErrands,
            totalCount: errands.length,
            currentCount: errands.length - undoneErrands.length
        }
    }, [errands])
}
